module.exports = __webpack_public_path__ + "img/橙-选中@3x.5a7cef4e.png";